import { useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "./hooks/useRouter";

import store from "./store/index.js";
import { Provider } from "react-redux";

// Pages
import Login from "./pages/Login/Login.jsx";
import Chat from "./pages/Chat/Chat.jsx";
import VideoTutorials from "./pages/VideoTutorials/VideoTutorials.jsx";
import GMTChat from "./pages/GMTChat/GMTChat.jsx";
import ProcurementChat from "./pages/ProcurementChat/ProcurementChat.jsx";
import DeepInsightsChat from "./pages/DeepInsightsChat/DeepInsightsChat.jsx";
import Layout from "./pages/Layout/Layout.jsx";
import Translate from "./pages/Translate/Translate.jsx";
import Decrypt from "./pages/Decrypt/Decrypt.jsx";
import UserManagement from "./pages/UserManagement/UserManagement.jsx";
import Apps from "./pages/My Apps/MyApps.jsx";
import TalentPulse360 from "./pages/TalentPulse360/TalentPulse360.jsx";
import TalentPulse360Admin from "./pages/TalentPulse360/TalentPulse360Admin.jsx";
import TalentPulse360Survey from "./pages/TalentPulse360/TalentPulse360Survey.jsx";

// services and contexts
import { EventEmitterProvider } from "./contexts/EventEmmiter.js";
import TourProvider from "./contexts/TourProvider.js";
import ProtectedRoute, { RestrictedRoute, LandingRedirect } from "./services/AuthGaurd.jsx";
import { ROLE_ACCESS, ROUTES } from "./constant/keyConstants.js";
import { REQUIRE_AUTH } from "./constant/globalConstants.js";

import { RBAC_APPS } from "./constant/rbacConfig.js";
import Maintenance from "./components/Maintenance/Maintenance.jsx";

function App() {
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === "true";

  useEffect(() => {
    const isInApp = /MyAppName|WebView|wv/i.test(navigator.userAgent);
    if (isInApp) {
      document.body.classList.add("in-app");
    } else {
      document.body.classList.remove("in-app");
    }
  }, []);

  if (isMaintenanceMode) {
    return <Maintenance />;
  }

  // Check if decrypt page should be shown based on URL
  const shouldShowDecrypt = () => {
    const hostname = window.location.hostname;
    return hostname.includes('localhost') || hostname.includes('dev');
  };

  return (
    <div className="app-main-container">
      <Router>
        <EventEmitterProvider>
          <Provider store={store}>
            <TourProvider>
              {/* <SessionExpiration> */}
              <Routes>
                <Route element={<ProtectedRoute element={Layout} />}>
                  <Route
                    path="video-tutorials"
                    element={<VideoTutorials />}
                  />
                  <Route
                    path="my-apps"
                    element={<Apps />}
                  />

                  <Route
                    path="chat"
                    element={<RestrictedRoute element={Chat} appName={RBAC_APPS.CHAT_GENIE} />}
                  />
                  <Route
                    path="gmt-chat"
                    element={<RestrictedRoute element={GMTChat} appName={RBAC_APPS.GMT} />}
                  />
                  <Route
                    path="proc-ai"
                    element={<RestrictedRoute element={ProcurementChat} appName={RBAC_APPS.PROCUREMENT} />}
                  />
                  <Route
                    path="deep-insights-chat"
                    element={<RestrictedRoute element={DeepInsightsChat} appName={RBAC_APPS.DEEP_INSIGHTS} />}
                  />
                  <Route
                    path="talent-pulse-360"
                    element={<RestrictedRoute element={TalentPulse360} appName={RBAC_APPS.TALENT_PULSE_360} />}
                  />
                  <Route
                    path="talent-pulse-360-admin"
                    element={<RestrictedRoute element={TalentPulse360Admin} appName={RBAC_APPS.TALENT_PULSE_360} allowedAppRoles={[ROLE_ACCESS.SUPERADMIN]} redirectTo={ROUTES.TALENT_PULSE_360} restrictMobile={true} />}
                  />
                  <Route
                    path="talent-pulse-360-survey"
                    element={<RestrictedRoute element={TalentPulse360Survey} appName={RBAC_APPS.TALENT_PULSE_360} allowedAppRoles={[ROLE_ACCESS.SUPERADMIN]} redirectTo={ROUTES.TALENT_PULSE_360} restrictMobile={true} />}
                  />
                  {shouldShowDecrypt() && (
                    <Route
                      path="decrypt"
                      element={<Decrypt />}
                    />
                  )}
                  <Route
                    path="translate"
                    element={<RestrictedRoute element={Translate} restrictMobile={true} appName={RBAC_APPS.TRANSLATION} />}
                  />
                  <Route
                    path="user-management"
                    element={<RestrictedRoute element={UserManagement} allowedRoles={[ROLE_ACCESS.SUPERADMIN]} />}
                  />
                </Route>
                <Route
                  path="sign-in"
                  element={REQUIRE_AUTH ? <Login /> : <LandingRedirect />}
                />
                <Route path="*" element={REQUIRE_AUTH ? <Navigate to="/sign-in" /> : <LandingRedirect />} />
              </Routes>
              {/* </SessionExpiration> */}
            </TourProvider>
          </Provider>
        </EventEmitterProvider>
      </Router>
    </div>
  );
}

export default App;
